module.exports = __webpack_public_path__ + "static/media/clue-6.b4160c78.svg";